import * as React from "react";
import { useEffect, useState, useContext } from "react";
import Header from "../components/Header";
import { Loader } from "../components/Loader";
import Footer from "../components/Footer";
import { colors } from "../constants/colourConfigurations";
import "./ComponentStyles.css";
import { CookieService } from "../utils/cookieservice";
import Logo from "../assets/AgileAp-Logo-icon.png";
import { useLocation } from "react-router-dom";

interface Home_DesktopProps {
  mainContent: React.ReactNode;
  currentPage?: string;
  showOverlay?: boolean;
  overlayContent?: React.ReactNode;
  overlayStyleClass?: string;
  overlayWidth?: string;
  overlayHeight?: string;
  handleOverlayExit?: () => void;
  isLoading?: boolean;
  loadingMessage?: string;
  showHeader?: boolean;
  showFooter?: boolean;
}

export const HomeLayout = ({
  mainContent,
  currentPage,
  showOverlay,
  overlayContent,
  overlayStyleClass,
  overlayHeight,
  overlayWidth,
  handleOverlayExit = () => {},
  isLoading = false,
  loadingMessage,
  showHeader = true,
  showFooter = true,
}: Home_DesktopProps) => {
  const location = useLocation();
  const isSingaporeSite = location.pathname.split("/").filter(Boolean)[0]?.toLowerCase() === "sg";
  const baseName = process.env.REACT_APP_BASENAME ? process.env.REACT_APP_BASENAME : "";

  useEffect(() => {
    window.scrollTo(0, 0);
    handleLogout();
  }, []);

  const handleLogout = async () => {
    if ("caches" in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
    const rememberMeValue = localStorage.getItem("rememberMe");
    const userName = localStorage.getItem("u");
    const password = localStorage.getItem("c");
    const country = localStorage.getItem("country");
    CookieService.remove("x-token");
    const remove = async () => {
      localStorage.clear();
      localStorage.removeItem("version");
      CookieService.removeAll();
      localStorage.setItem("rememberMe", rememberMeValue ? rememberMeValue : "");
      localStorage.setItem("u", userName ? userName : "");
      localStorage.setItem("c", password ? password : "");
      localStorage.setItem("country", country ? country : "");
      //window.location.reload();
    };
    await remove();
  };
  const [mainUrl, setMainUrl] = useState(process.env.REACT_APP_IMAGE_URL ? process.env.REACT_APP_IMAGE_URL : "https://agileap.com/");
  const [isAdVisible, setIsAdVisible] = useState(true);

  const toggleAdVisibility = () => {
    setIsAdVisible(!isAdVisible);
  }

  return (
    <div
      style={currentPage === "Timing" ? {} : {}}
      className={`flex w-full bg-white flex-col items-center justify-between font-[inter] ${
        currentPage === "Timing" && "countdown-container"
      }`}
    >
      {showHeader && <Header currentPage={currentPage} />}
      {isLoading === false && mainContent}
      {isLoading == true && (
        <div className={"w-full grid grid-cols-1 content-center "}>
          <div className={"flex w-full justify-center "}>
            <Loader size={75} className={"flex"} visibility={true} colour={colors.secondary} loadingText={""} />
          </div>
          <div className="flex w-full justify-center pt-2 font-bold text-primary">{loadingMessage}</div>
        </div>
      )}
      {showFooter && <Footer />}
      {isSingaporeSite && <div className={`fixed bottom-5 left-5 rounded-lg py-2 px-3 bg-black text-gray-100 font-normal z-50 ${isAdVisible ? "" : "hidden"}`}>
        <div className="relative grid grid-cols-8 xl:w-[35vw] lg:w-[50vw] md:w-[70vw] sm:w-[65vw] w-[85vw]">
          <button
            className="absolute top-0 right-0 w-6 h-6 pb-0.5 bg-gray-700 hover:bg-gray-600 text-white rounded-full flex items-center justify-center font-bold text-lg transition-colors duration-200 cursor-pointer border-none"
            onClick={toggleAdVisibility}
            aria-label="Close advertisement"
          >
            ×
          </button>
          <div className="flex items-center justify-center">
            <img src={Logo} alt="Logo" className="w-[50px]" />
          </div>
          <div className="col-span-7 px-2 md:grid md:grid-cols-7">
            <div className="md:col-span-5">
              <div className="font-bold text-base text-center sm:text-left">Claim Your InvoiceNow Free Package Today!</div>
              <div className="text-sm text-gray-300 hidden md:block">
                If your business is GST-registered in Singapore, you're eligible to enjoy the{" "}
                <span className="font-bold">FOC InvoiceNow Package</span>, with{" "}
                <span className="font-bold">FREE access until 31 March 2031</span>. Register today and start sending and receiving InvoiceNow e-invoices at no cost.
              </div>
            </div>
            <div className="flex items-center justify-center md:col-span-2 col-span-8 sm:px-4 mt-2 mb-1" onClick={()=>{window.open(mainUrl+"freemium");}}>
              <button className="bg-[#6940ff] rounded-full md:h-10 md:w-full w-[30vw] h-8 bg-linear-to-t from-[#3e36a6] to-[#6940ff]">
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
};
